import { useState } from 'react'
import { useFormikContext } from 'formik'

export function useInvitationModalHandlers() {
  const { setValues } = useFormikContext()

  const [showInvitationModal, setShowInvitationModal] = useState(false)

  function handleOpenInvitationModal() {
    setShowInvitationModal(true)
  }

  function handleCloseInvitationModal() {
    setShowInvitationModal(false)
  }

  function handleSubmitInvitationModal(values) {
    handleCloseInvitationModal()

    setValues(prevValues => {
      return { ...prevValues, ...values }
    })
  }

  return {
    handleCloseInvitationModal,
    handleOpenInvitationModal,
    handleSubmitInvitationModal,
    showInvitationModal,
  }
}
